module.exports = false;



//////////////////
// WEBPACK FOOTER
// /home/kalinin/angular2/PRACTICE/feedback/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0